import { render, staticRenderFns } from "./localizedFilter.vue?vue&type=template&id=0d4f084b&scoped=true"
import script from "./localizedFilter.vue?vue&type=script&lang=js"
export * from "./localizedFilter.vue?vue&type=script&lang=js"
import style0 from "./localizedFilter.vue?vue&type=style&index=0&id=0d4f084b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4f084b",
  null
  
)

export default component.exports